// extracted by mini-css-extract-plugin
export var actionButton = "_ne-0";
export var actionMenuContainer = "_ne-i";
export var bubble = "_ne-2";
export var bubbleActionMenu = "_ne-j";
export var bubbleContext = "_ne-6";
export var bubbleItems = "_ne-7";
export var customer = "_ne-3";
export var divider = "_ne-8";
export var fileList = "_ne-9";
export var hiddenComment = "_ne-o";
export var infoAbove = "_ne-a";
export var internal = "_ne-4";
export var lightActionButton = "_ne-1";
export var link = "_ne-b";
export var merchant = "_ne-5";
export var message = "_ne-c";
export var profilePicture = "_ne-e";
export var quillToolbarContainer = "_ne-f";
export var senderDate = "_ne-g";
export var senderDateCustomer = "_ne-h";
export var senderName = "_ne-d";
export var time = "_ne-k";
export var uploadedImage = "_ne-l";
export var username = "_ne-m";
export var xsmall = "_ne-n";